import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 text-center cursor-pointer';
  const variants = {
    primary: 'bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 text-slate-900 hover:from-yellow-300 hover:via-yellow-400 hover:to-yellow-500 shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] hover:-translate-y-1',
    secondary: 'bg-transparent border-2 border-yellow-500 text-yellow-400 hover:bg-yellow-500/10 shadow-[0_0_10px_rgba(212,175,55,0.2)] hover:shadow-[0_0_20px_rgba(212,175,55,0.4)]'
  };
  const sizes = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (href.startsWith('#')) {
        e.preventDefault();
        const target = document.getElementById(href.slice(1));
        target?.scrollIntoView({
          behavior: 'smooth'
        });
      }
    };
    return <a href={href} className={combinedClassName} onClick={handleClick} data-id="element-35">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-36">
      {children}
    </button>;
}